export default "__VITE_ASSET__pzT_b216__"